import React from 'react'
import Icon from '../../../components/AppIcon'

/**
 * Scaffold for an Exchange Desk admin section that is not yet built.
 * Shows the section identity + the planned contents from the rebuild spec,
 * so the menu structure is usable while each area is filled in per phase.
 */
export default function ExchangeAdminSection({ section }) {
  return (
    <div className="bg-card rounded-2xl border border-border p-8 sm:p-10">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
          <Icon name={section.icon} size={24} />
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h2 className="text-xl font-semibold text-foreground">{section.label}</h2>
            <span className="inline-block px-2.5 py-0.5 rounded-full bg-warning/15 border border-warning/25 text-[11px] font-semibold uppercase tracking-wide text-warning">
              In progress
            </span>
          </div>
          <p className="text-sm text-muted-foreground mt-1">{section.description}</p>
        </div>
      </div>

      {section.planned?.length > 0 && (
        <div className="mt-6 border-t border-border pt-5">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
            Coming to this screen
          </p>
          <ul className="space-y-2">
            {section.planned.map((item, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-foreground/80">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
